<template>
  <div class="completeLicense">
    <h1>Complete License</h1>

    <el-table :data="licenseRecordData" style="width: 100%">
      <el-table-column prop="outerlicense" label="Outer License"></el-table-column>
      <el-table-column prop="interlicense" label="Inter License"></el-table-column>
      <el-table-column prop="er_num" label="ER Number" :formatter="arrayFormat"></el-table-column>
      <el-table-column prop="license_content" label="License Content" :formatter="jsonFormat"></el-table-column>
      <el-table-column prop="project" label="Project Name"></el-table-column>
      <el-table-column prop="direct_cus" label="Direct Customer"></el-table-column>
      <el-table-column prop="user_email" label="Customer Email"></el-table-column>
      <el-table-column prop="exp_date" label="Expiry Date [as UTC(+00:00)]" :formatter="dateFormat"></el-table-column>
    </el-table>

    <router-link to='welcome'>
      <el-button type="success" plain>OK</el-button>
    </router-link>

    <el-button type="primary" plain @click="onClick()" :loading="downloading">DownLoad<i class="el-icon-download el-icon--right"></i></el-button>

  </div>
</template>

<script>
import {downloadLicense} from '../api'
import moment from 'moment'
export default {
  name: 'CompleteLicense',
  data () {
    console.log(this.$route.params.data)
    return {
      downloading: false,
      LicenseInfo: this.$route.params.data,
      licenseRecordData: [this.$route.params.data]
    }
  },
  methods: {
    onClick () {
      console.log('onClick Download')
      this.downloading = true

      downloadLicense(this.LicenseInfo.outerlicense, this.LicenseInfo.interlicense).then(data => {
        var fileURL = window.URL.createObjectURL(new Blob([data]))
        var fileLink = document.createElement('a')
        var fileName = 'license_' + this.LicenseInfo.outerlicense + '.lic'

        console.log('fileName = ', fileName)

        fileLink.href = fileURL
        fileLink.setAttribute('download', fileName)
        document.body.appendChild(fileLink)

        fileLink.click()
        this.downloading = false
      }).catch(error => {
        if (error) {
          console.log(error.stack)
        }
        this.downloading = false
      })
    },
    // Format Timestamps
    dateFormat: function (row, column) {
      var date = row[column.property]
      if (date === -1) {
        return 'No Limit'
      }
      if (date === undefined) {
        return ''
      }
      return moment.utc(date).format('YYYY-MMM-DD', true)
    },
    jsonFormat: function (row, column) {
      var jsonObj = row[column.property]
      if (jsonObj === undefined) {
        return ''
      }
      const jsonStr = JSON.stringify(jsonObj)
      return jsonStr
    },
    arrayFormat: function (row, column) {
      var arrayInput = row[column.property]
      if (arrayInput === undefined) {
        return ''
      }
      if (Array.isArray(arrayInput)) {
        return arrayInput.join()
      } else {
        return arrayInput
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.welcome{
  margin: 0px auto;
  max-width: 350px;
  position: relative;
  margin-top: 50px;
}
</style>

<style>
.el-table .cell {
  word-break: break-word;
}
</style>



// WEBPACK FOOTER //
// CompleteLicense.vue?9c34f182